module.exports = __webpack_public_path__ + "img/img-a37eff6c.3e3a4e84.png";